// extracted by mini-css-extract-plugin
module.exports = {"distance":"_7a3fb80146--distance--EnGTZ","icon":"_7a3fb80146--icon--ylVel"};